module.exports = __webpack_public_path__ + "static/media/tecnologia_bco.de1150cb.svg";